import type { TableWidget } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import { uuid } from '@piccolohealth/util';
import React from 'react';
import { createModal } from '../../../../components/generic/Modal';
import { TableWidgetModalContent } from './TableWidgetModalContent';

interface Props {
  participantId: string;
  onAdd: (item: TableWidget) => void;
}

export const TableWidgetAddModal = createModal<Props>((props) => {
  const { modal, participantId, onAdd } = props;

  const { visible, hide, remove } = modal;

  const onSubmit = (widget: TableWidget) => {
    hide();
    onAdd(widget);
  };

  const widget: TableWidget = React.useMemo(
    () => ({
      __typename: 'TableWidget',
      id: uuid(),
      series: [],
      title: 'New table',
    }),
    [],
  );

  return (
    <ChakraV3.Dialog.Root
      open={visible}
      onOpenChange={hide}
      onExitComplete={remove}
      size='cover'
      scrollBehavior='inside'
    >
      <ChakraV3.Dialog.Backdrop />
      <ChakraV3.Dialog.Positioner>
        <ChakraV3.Dialog.Content>
          <ChakraV3.Dialog.Body p={2}>
            <TableWidgetModalContent
              participantId={participantId}
              onSubmit={onSubmit}
              widget={widget}
            />
          </ChakraV3.Dialog.Body>
        </ChakraV3.Dialog.Content>
      </ChakraV3.Dialog.Positioner>
    </ChakraV3.Dialog.Root>
  );
});
